module.exports = __webpack_public_path__ + "img/9.db784e9d.jpg";